var map = {
	"./accenture.png": 8518,
	"./akamaitt.png": 526,
	"./amazon.png": 5612,
	"./bhanzutt.png": 8689,
	"./fivetran.png": 6104,
	"./takeofftt.png": 5459,
	"./ulatt.png": 7048,
	"./vmware.white.png": 616,
	"./zstt.png": 5317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7791;